import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Button, TextField } from "@mui/material";
import Badge from "@mui/material/Badge";
import { PickersDay } from "@mui/x-date-pickers";
import { toJS } from "mobx";
import { inject, observer } from "mobx-react";
import moment from "moment";
import "dayjs/locale/vi";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import CompanyWorkScheduleCreate from "../modules/CompanyWorkSchedule/CompanyWorkScheduleCreate";
import Message from "../components/common/Message";
import { AiOutlineFieldTime } from "react-icons/ai";

const CompanyWorkSchedulePage = ({ workScheduleStore }) => {
  const [message, setMessage] = useState("");
  const [openMessage, setOpenMessage] = useState(false);
  const [severity, setSeverity] = useState("");
  const createMessage = (message, openMessage, severity) => {
    setMessage(message);
    setOpenMessage(openMessage);
    setSeverity(severity);
  };
  const [date, setDate] = useState(new Date());
  const [highlightedDays, setHighlightedDays] = useState([]);
  const navigate = useNavigate();

  let from_date = moment(date.$d).startOf("month").format("YYYY-MM-DD");
  let to_date = moment(date.$d).endOf("month").format("YYYY-MM-DD");

  useEffect(() => {
    workScheduleStore.getWorkSchedule(from_date, to_date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [workScheduleList, setWorkScheduleList] = useState([]);

  useEffect(() => {
    setWorkScheduleList(toJS(workScheduleStore.workScheduleList));
  }, [workScheduleStore.workScheduleList]);

  const handleClick = async () => {
    let dot = workScheduleList?.map((item) => {
      return Number(moment(item.start_at).format("DD"));
    });
    dot.unshift(0);
    setHighlightedDays(dot);
  };
  const theme = useTheme();

  useEffect(() => {
    handleClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(workScheduleList)]);

  const renderDay = (day, _value, DayComponentProps) => {
    const isSelected =
      !DayComponentProps.outsideCurrentMonth &&
      highlightedDays.indexOf(day.date()) > 0;

    return (
      <Badge
        key={day.toString()}
        overlap="circular"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        badgeContent={
          isSelected ? (
            <div className="w-[6px] h-[6px] bg-blue-500 rounded-full" />
          ) : undefined
        }
      >
        <PickersDay {...DayComponentProps} />
      </Badge>
    );
  };

  const [openCompanyWorkScheduleCreate, setOpenCompanyWorkScheduleCreate] =
    useState(false);

  return (
    <>
      <div
        style={{ backgroundColor: theme.background.base, minHeight: "850px" }}
      >
        <div
          className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px] fixed w-full z-50"
          style={{
            background: theme.background.header,
            color: theme.color.text1,
          }}
        >
          <div className="font-bold text-[28px] leading-[29px] ">
            Lịch cơ quan
          </div>
        </div>
        <MainLayout initialValue={1}>
          <div className="pt-20 ml-2 mr-2">
            <Button
              variant="contained"
              color="primary"
              style={{
                marginBottom: "10px",
                textTransform: "none",
              }}
              onClick={() => {
                setOpenCompanyWorkScheduleCreate(true);
              }}
            >
              Tạo sự kiện mới
            </Button>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <div id="custom-datepicker">
                <StaticDatePicker
                  displayStaticWrapperAs="desktop"
                  openTo="day"
                  value={date}
                  onChange={(newDate) => {
                    setDate(newDate);
                  }}
                  onMonthChange={(newValue) => {
                    let from_date = moment(newValue.$d)
                      .startOf("month")
                      .format("YYYY-MM-DD");
                    let to_date = moment(newValue.$d)
                      .endOf("month")
                      .format("YYYY-MM-DD");
                    workScheduleStore.getWorkSchedule(from_date, to_date);
                  }}
                  disableHighlightToday
                  renderInput={(params) => <TextField {...params} />}
                  renderDay={renderDay}
                  dayOfWeekFormatter={(day) => `${day}`}
                />
              </div>
            </LocalizationProvider>
            <div style={{ paddingBottom: "96px" }}>
              {workScheduleList?.map((item, index) => {
                return (
                  <div key={index}>
                    {moment(item.start_at).format("DD/MM/YYYY") ===
                    moment(date.$d).format("DD/MM/YYYY") ? (
                      <div
                        className="my-2"
                        onClick={() =>
                          navigate(
                            `/company-work-schedule/view/${item.schedule_code}`
                          )
                        }
                      >
                        <div
                          className=" rounded-2xl py-4 px-[18px]"
                          style={{ background: theme.color.text1 }}
                        >
                          <div
                            // className="font-[600]"
                            style={{
                              display: "flex",
                              color: theme.color.time,
                              alignItems: "center",
                            }}
                          >
                            <AiOutlineFieldTime
                              style={{
                                color: "#2c65ac",
                                marginRight: "5px",
                                fontSize: "20px",
                              }}
                            />

                            {item.start_at !== null && item.end_at !== null ? (
                              <div>
                                {moment(item?.start_at).format("HH:mm")} tới{" "}
                                {moment(item?.end_at).format("HH:mm")}
                              </div>
                            ) : (
                              <div>
                                Bắt đầu lúc{" "}
                                {moment(item?.start_at).format("HH:mm")}
                              </div>
                            )}
                          </div>
                          <div className="font-semibold text-[#161616] mb-1 mr-1">
                            Nội dung:
                          </div>
                          <div style={{ marginLeft: "10px" }}>
                            {item?.event_notice ? (
                              <div
                                // className="font-[600]"
                                dangerouslySetInnerHTML={{
                                  __html: item.event_notice,
                                }}
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  width: "100%",
                                  lineHeight: "25px",
                                  WebkitLineClamp: "3",
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  maxHeight: "75px",
                                  margin: "2px",
                                }}
                              />
                            ) : (
                              "không có nội dung"
                            )}
                          </div>

                          <div className="font-semibold text-[#161616] mb-1 mr-1">
                            Địa chỉ:
                          </div>
                          <div
                            style={{
                              overflowWrap: "anywhere",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              width: "100%",
                              lineHeight: "25px",
                              WebkitLineClamp: "1",
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              maxHeight: "75px",
                              margin: "2px",
                              marginLeft: "10px",
                            }}
                          >
                            {item.location.indexOf("http") !== -1 ? (
                              <div>
                                {item.location.slice(
                                  0,
                                  item.location.indexOf("http")
                                )}{" "}
                                <a
                                  rel="noreferrer"
                                  href={item.location.slice(
                                    item.location.indexOf("http")
                                  )}
                                  target="_blank"
                                >
                                  {item.location.slice(
                                    item.location.indexOf("http")
                                  )}
                                </a>
                              </div>
                            ) : (
                              <div>{item.location}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </MainLayout>
      </div>
      <CompanyWorkScheduleCreate
        createMessage={createMessage}
        open={openCompanyWorkScheduleCreate}
        handleClose={() => setOpenCompanyWorkScheduleCreate(false)}
      />
      <Message
        message={message}
        openMessage={openMessage}
        severity={severity}
        closeMessage={() => {
          setOpenMessage(false);
        }}
      />
    </>
  );
};

export default inject("workScheduleStore")(observer(CompanyWorkSchedulePage));
